// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__26oiY","actions":"GroupTable_actions__3a4oZ","deleteModalFooter":"GroupTable_deleteModalFooter__1Kjj0"};